import format from 'root-core/utils/text/stringFormatFilter.js'
import * as validations from '../../../validations.js'
import parseUserSuppliedDate from '../../../parseUserSuppliedDate.js'

export default function (sellingCompany) {
  function present () {
    return validations.required(() => 'Please enter a trip name')
  }

  function pattern (regex, field) {
    return function (value) {
      if (!regex.test(value)) {
        return `Please enter a valid value for your ${field}.`
      }
    }
  }

  function parseDate (date) {
    if (typeof date === 'string') {
      return parseUserSuppliedDate(date, 'YYYY-MM-DD')
    }
  }

  function name (field) {
    return function (value, is) {
      is(present(field)) && is(pattern(/^[A-Za-z-' ]+$/, field))
    }
  }

  function date (value) {
    var date = parseDate(value)
    if (!date) {
      return format(
        sellingCompany.errorMessages.dateFormat,
        sellingCompany.dateFormat
      )
    }
  }

  return {
    name: name(),
    date: date,
  }
}
